var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderDetail" },
    [
      _c(
        "el-form",
        {
          ref: "orderDetailForm",
          staticClass: "demo-form-inline",
          attrs: {
            "status-icon": "",
            "label-position": "left",
            inline: true,
            model: _vm.orderDetailForm,
            rules: _vm.orderDetailRules
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "主订单号" } },
            [
              _c("el-input", {
                attrs: { disabled: true, placeholder: "主订单号" },
                model: {
                  value: _vm.orderDetailForm.main_number,
                  callback: function($$v) {
                    _vm.$set(_vm.orderDetailForm, "main_number", $$v)
                  },
                  expression: "orderDetailForm.main_number"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "推送时间" } },
            [
              _c("el-input", {
                attrs: { disabled: true, placeholder: "推送时间" },
                model: {
                  value: _vm.orderDetailForm.created_at,
                  callback: function($$v) {
                    _vm.$set(_vm.orderDetailForm, "created_at", $$v)
                  },
                  expression: "orderDetailForm.created_at"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "要求发货日" } },
            [
              _c("el-input", {
                attrs: { disabled: true, placeholder: "要求发货日" },
                model: {
                  value: _vm.orderDetailForm.out_ware_day,
                  callback: function($$v) {
                    _vm.$set(_vm.orderDetailForm, "out_ware_day", $$v)
                  },
                  expression: "orderDetailForm.out_ware_day"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "客户" } },
            [
              _c("el-input", {
                attrs: { disabled: true, placeholder: "客户" },
                model: {
                  value: _vm.orderDetailForm.user_name,
                  callback: function($$v) {
                    _vm.$set(_vm.orderDetailForm, "user_name", $$v)
                  },
                  expression: "orderDetailForm.user_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isFactory
            ? _c(
                "el-form-item",
                { attrs: { label: "客户电话" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true, placeholder: "客户电话" },
                    model: {
                      value: _vm.orderDetailForm.mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.orderDetailForm, "mobile", $$v)
                      },
                      expression: "orderDetailForm.mobile"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isFactory
            ? _c(
                "el-form-item",
                { attrs: { label: "客户地址" } },
                [
                  _c("el-input", {
                    staticStyle: { "font-size": "12px" },
                    attrs: {
                      type: "textarea",
                      disabled: true,
                      placeholder: "客户地址"
                    },
                    model: {
                      value: _vm.orderDetailForm.address,
                      callback: function($$v) {
                        _vm.$set(_vm.orderDetailForm, "address", $$v)
                      },
                      expression: "orderDetailForm.address"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态" } },
            [
              _c(
                "el-select",
                {
                  attrs: { disabled: true, placeholder: "状态" },
                  model: {
                    value: _vm.orderDetailForm.mo_status,
                    callback: function($$v) {
                      _vm.$set(_vm.orderDetailForm, "mo_status", $$v)
                    },
                    expression: "orderDetailForm.mo_status"
                  }
                },
                _vm._l(_vm.od_statusList, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "订货总数量" } },
            [
              _c("el-input", {
                attrs: { disabled: true, placeholder: "订货总数量" },
                model: {
                  value: _vm.orderDetailForm.totalAmount,
                  callback: function($$v) {
                    _vm.$set(_vm.orderDetailForm, "totalAmount", $$v)
                  },
                  expression: "orderDetailForm.totalAmount"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "goodsInfo" }, [_vm._v("商品信息")]),
      _vm._v(" "),
      _c("order-detail-table", {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loadingDetail,
            expression: "loadingDetail"
          }
        ],
        attrs: { orderDetailTableData: _vm.orderDetailTableData },
        on: { updateOrder: _vm.getOrderDetail }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b7ccd7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b7ccd7d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bigorder/order-detail.vue
// module id = null
// module chunks = 